import { Button } from 'antd';
import React from 'react';


const ButtonCellRenderer = (props) => {

    const { data, onButtonClick } = props;

    const handleButtonClick = (buttonType) => {
        if (buttonType === 'button1') {
          onButtonClick(buttonType, data); 
        } else if (buttonType === 'button2') {
          onButtonClick(buttonType, data); 
        }
      };
    
    return (
        <div><div style={{ display: 'flex', gap: '6px', marginTop: '7px' }}>
            <Button 
                type="link"
                style={{fontWeight:"400",color:"#164897"}}
                onClick={() => handleButtonClick('button1')}
            >
                {props.buttonName}
            </Button></div></div>
    );
}

export default ButtonCellRenderer;


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/vonboard/button-cell-renderer.js